import { AppElement, AppFC } from '../../../interfaces';

export const CloseIcon: AppFC = ({ className }): AppElement => (
  <svg className={className || ''} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
    <path d="M6 18L18 6M6 6L18 18" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);
